/* Bloque 127: precio unificado ZTK (snippets/ztk-price.liquid).
   1) ZTKPrice.novat / fmt / markup: MISMA fórmula que el snippet Liquid
      (céntimos * 200 + 121) / 242 en enteros = céntimos / 1,21 redondeado a 2 decimales.
      Lo usa la barra sticky para repintarse al cambiar de variante.
   2) Ajuste a una sola línea de todos los [data-ztk-price]: primero cede el precio sin IVA
      (nunca por debajo del mínimo de su tamaño), después se usa "IVA incl." y, solo si aun así
      no cabe, se reducen tachado e IVA (mínimo 70%). */
(function () {
  if (window.ZTKPrice) return;

  var CFG = {
    lg: { base: 42, floor: 24 },
    md: { base: 18, floor: 14 },
    sm: { base: 20, floor: 13 }
  };

  function novat(cents) {
    return Math.floor((cents * 200 + 121) / 242);
  }

  function fmt(cents) {
    var parts = (Math.abs(cents) / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts[0] + ',' + parts[1];
  }

  function markup(variant, size) {
    var price = variant && variant.price;
    if (!price || price <= 0) return '';
    var sale = variant.compare_at_price && variant.compare_at_price > price;
    return '<div class="ztk-price ztk-price--' + size + (sale ? ' ztk-price--on-sale' : '') +
      '" data-ztk-price data-ztk-price-size="' + size + '"><div class="ztk-price__line">' +
      (sale ? '<s class="ztk-price__compare">' + fmt(variant.compare_at_price) + ' €</s>' : '') +
      '<span class="ztk-price__main">' + fmt(novat(price)) + ' €</span>' +
      '<span class="ztk-price__iva"><span class="ztk-price__iva-amount">' + fmt(price) + ' €</span> ' +
      '<span class="ztk-price__iva-label"><span class="ztk-price__label-full">IVA incluido</span>' +
      '<span class="ztk-price__label-short">IVA incl.</span></span></span></div></div>';
  }

  function availableWidth(el) {
    var p = el.parentElement;
    if (!p) return 0;
    var cs = getComputedStyle(p);
    return p.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
  }

  function fit(el, force) {
    var line = el.querySelector('.ztk-price__line');
    if (!line) return;
    var w = availableWidth(el);
    if (w <= 0) return;
    if (!force && el._zpWidth === w && el._zpDone) return;
    var size = el.getAttribute('data-ztk-price-size');
    var cfg = CFG[size] || CFG.sm;
    var lg = size === 'lg';

    function over() { return line.offsetWidth > w + 0.5; }
    function setScale(s) {
      if (s === 1) el.style.removeProperty('--zp-sec');
      else el.style.setProperty('--zp-sec', s);
    }

    el.classList.remove('ztk-price--compact');
    setScale(1);
    var px = cfg.base;
    el.style.setProperty('--zp-main', px + 'px');
    while (over() && px > cfg.floor) {
      px -= 1;
      el.style.setProperty('--zp-main', px + 'px');
    }
    if (over() && !lg) el.classList.add('ztk-price--compact');
    var scale = 1;
    while (over() && scale > 0.7) {
      scale = Math.round((scale - 0.02) * 100) / 100;
      setScale(scale);
    }
    if (over() && lg) {
      el.classList.add('ztk-price--compact');
      while (over() && scale > 0.7) {
        scale = Math.round((scale - 0.02) * 100) / 100;
        setScale(scale);
      }
    }
    el._zpWidth = w;
    el._zpDone = true;
  }

  var pending = new Set();
  var raf = 0;
  var observed = new WeakSet();
  var ro = window.ResizeObserver ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.querySelectorAll(':scope > [data-ztk-price]').forEach(function (el) { pending.add(el); });
    });
    schedule();
  }) : null;

  function queue(el) {
    pending.add(el);
    if (ro && el.parentElement && !observed.has(el.parentElement)) {
      observed.add(el.parentElement);
      ro.observe(el.parentElement);
    }
  }

  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.hasAttribute('data-ztk-price')) queue(root);
    root.querySelectorAll('[data-ztk-price]').forEach(queue);
  }

  function schedule() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      var list = Array.from(pending);
      pending.clear();
      list.forEach(function (el) { if (el.isConnected) fit(el); });
    });
  }

  function refitAll() {
    document.querySelectorAll('[data-ztk-price]').forEach(function (el) { el._zpDone = false; queue(el); });
    schedule();
  }

  function start() {
    scan(document.body);
    schedule();
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) { m.addedNodes.forEach(scan); });
      if (pending.size) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', refitAll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refitAll);
  }

  window.ZTKPrice = { novat: novat, fmt: fmt, markup: markup, fit: fit };

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
